import RepairOrderResponse from 'src/adminPanel/entities/service/RepairOrderResponse';
import callApi, { CallApiResult } from 'src/api';

export const fetchRepairOrders = (): Promise<CallApiResult> => {
    const endpoint = `/api/complaints/repairs`;
    return callApi(endpoint);
};

export const finishRepairOrder = (claimId: string, data: RepairOrderResponse) => {
    const endpoint = `/api/complaints/${claimId}/finishRepair`;
    return callApi(endpoint, { method: 'POST', data });
};
